import { Capacitor } from '@capacitor/core';
export const isNativePlatform = ()=>Capacitor.isNativePlatform();
